import React from 'react';
import { Award, X, Eye, DollarSign, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const AlertaObjetivosNovos = ({ objetivos, onClose, onMarcarVisualizado }) => {
  if (!objetivos || objetivos.length === 0) return null;

  const handleMarcarTodosVisualizado = async () => {
    for (const objetivo of objetivos) {
      await onMarcarVisualizado(objetivo.id);
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg max-w-3xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-border bg-gradient-to-r from-primary/10 to-primary/5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-primary/20 rounded-full">
                <Award className="h-8 w-8 text-primary" />
              </div>
              <div>
                <h2 className="text-2xl font-bold">Novos Objetivos!</h2>
                <p className="text-sm text-muted-foreground">
                  {objetivos.length} {objetivos.length === 1 ? 'objetivo novo' : 'objetivos novos'} disponíveis para você
                </p>
              </div>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="hover:bg-destructive/10"
            >
              <X className="h-5 w-5" />
            </Button>
          </div>
        </div>

        {/* Body com scroll */}
        <div className="p-6 overflow-y-auto max-h-[60vh] space-y-4">
          {objetivos.map((objetivo) => (
            <Card key={objetivo.id} className="border-2 border-primary/20 bg-gradient-card">
              <CardHeader className="pb-3">
                <CardTitle className="text-lg flex items-center gap-2">
                  <TrendingUp className="h-5 w-5 text-primary" />
                  {objetivo.titulo}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                {objetivo.descricao && (
                  <p className="text-sm text-muted-foreground">{objetivo.descricao}</p>
                )}
                
                <div className="grid grid-cols-2 gap-4">
                  {/* Meta */}
                  <div className="p-3 bg-primary/5 rounded-lg">
                    <p className="text-xs text-muted-foreground mb-1">Meta</p>
                    <p className="text-lg font-bold text-primary">
                      {objetivo.tipo_meta === 'valor' 
                        ? `€${objetivo.meta_valor.toFixed(2)}`
                        : `${objetivo.meta_valor} ${objetivo.unidade_meta || 'unidades'}`}
                    </p>
                  </div>
                  
                  {/* Recompensa */}
                  <div className="p-3 bg-success/10 rounded-lg">
                    <p className="text-xs text-muted-foreground mb-1">Recompensa</p>
                    <div className="flex items-center gap-2">
                      {objetivo.tipo_recompensa === 'dinheiro' ? (
                        <DollarSign className="h-4 w-4 text-success" />
                      ) : (
                        <Award className="h-4 w-4 text-warning" />
                      )}
                      <p className="text-lg font-bold text-success">
                        {objetivo.tipo_recompensa === 'dinheiro' 
                          ? `€${objetivo.valor_recompensa.toFixed(2)}`
                          : `${objetivo.valor_recompensa} pontos`}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Período */}
                <div className="text-sm">
                  <span className="font-semibold">Válido até: </span>
                  <span className="text-primary">
                    {new Date(objetivo.data_fim).toLocaleDateString('pt-PT')}
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-border bg-muted/10">
          <div className="flex gap-3 justify-end">
            <Button 
              variant="outline" 
              onClick={onClose}
            >
              Fechar
            </Button>
            <Button 
              onClick={handleMarcarTodosVisualizado}
              className="bg-primary hover:bg-primary/90"
            >
              <Eye className="h-4 w-4 mr-2" />
              Marcar como Visualizado
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertaObjetivosNovos;
